import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";

import sfAuth from "~/auth/SFAuth";

interface PortalAuthInfo {
	customerId: string;
	email: string;
	isCustomer: boolean;
	tenantId: string;
	userId: string;
	userType: string;
}

/**
 * Provides portal-specific auth info derived directly from the JWT.
 * Reads everything the portal needs from the access token claims.
 */
function usePortalAuth(): PortalAuthInfo {
	const tokens = sfAuth.getTokens();

	return useMemo(() => {
		if (!tokens?.accessToken) {
			return { customerId: "", email: "", isCustomer: false, tenantId: "", userId: "", userType: "" };
		}

		const decoded = jwtDecode<SFJWT>(tokens.accessToken);
		const userType = decoded.wsUserType ?? "";

		return {
			customerId: decoded.wsCustomerId ?? "",
			email: decoded.email ?? "",
			isCustomer: userType === "customer" && !!decoded.wsCustomerId,
			tenantId: decoded.wsTenantId,
			userId: decoded.sub,
			userType
		};
	}, [tokens?.accessToken]);
}

export default usePortalAuth;
